import '../styles/LandingPage/Footer.css';
import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const footerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = entry.target.querySelectorAll('.ft-main > *');
            children.forEach((child) => {
              child.style.animationPlayState = 'running';
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const children = footerRef.current?.querySelectorAll('.ft-main > *');
    children?.forEach((child) => {
      child.style.animationPlayState = 'paused';
    });

    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <footer className="site-footer" ref={footerRef}>
      {/* Wave divider */}
      <div className="ft-wave">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
          <path d="M0,40 C360,80 720,0 1080,40 C1260,60 1380,30 1440,40 L1440,80 L0,80 Z" />
        </svg>
      </div>

      <div className="ft-main">
        {/* Brand Column */}
        <div className="foot-brand">
          <div className="foot-logo">ACTYRA</div>
          <div className="foot-tag">Clarity in Risk and Capital</div>
          <p className="foot-desc">
            Independent actuarial research and advisory for African insurers,
            pension funds, and regulators. Delivering precision since 2025.
          </p>
          <div className="ft-social">
            <a href="https://www.linkedin.com/company/actyr%C7%8E/?viewAsMember=true" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="ti ti-brand-linkedin" /></a>
            <a href="https://x.com/actyralimited" target="_blank" rel="noopener noreferrer" aria-label="Twitter / X"><i className="ti ti-brand-x" /></a>
            <a href="https://www.instagram.com/actyralimited/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="ti ti-brand-instagram" /></a>
            <a href="https://web.facebook.com/profile.php?id=61577411862890" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="ti ti-brand-facebook" /></a>
            <a href="mailto:info@actyra.co.ke" aria-label="Email"><i className="ti ti-mail" /></a>
          </div>
        </div>

        {/* Navigation Column */}
        <div className="ft-col">
          <h4>Navigate</h4>
          <div className="foot-links">
            <a href="#about">About</a>
            <a href="#research">Research</a>
            <a href="#advisory">Advisory</a>
            <a href="#phases">Phases</a>
            <Link to="/contact">Contact</Link>
          </div>
        </div>

        {/* Research Column */}
        <div className="ft-col">
          <h4>Research</h4>
          <div className="foot-links">
            <a href="#research">Financial Reporting</a>
            <a href="#research">Solvency &amp; Capital</a>
            <a href="#research">Mortality Studies</a>
            <a href="#research">Asset-Liability</a>
            <a href="#research">Emerging Risk</a>
          </div>
        </div>

        {/* Newsletter Column */}
        <div className="ft-col">
          <h4>Stay Updated</h4>
          <div className="ft-newsletter">
            <p>Get the latest actuarial insights delivered to your inbox.</p>
            <div className="ft-input-wrap">
              <input type="email" placeholder="your@email.com" />
              <button aria-label="Subscribe">
                <i className="ti ti-arrow-right" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="ft-bottom">
        <div className="copy">© 2025 Actyra. All rights reserved.</div>
        <div className="ft-legal">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Use</Link>
          <Link to="/data-usage">Data Usage Policy</Link>
        </div>
      </div>
    </footer>
  );
}
